import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { StartupSpinnerComponent } from '@plugins/client/spinners';
import { TranslateService } from '@plugins/client/translate/services';
import { setWindowTitleFromJWT } from '@plugins/shared/utils/title-from-jwt';

@Component({
  selector: 'usersync-root',
  imports: [RouterModule, StartupSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  protected translateService = inject(TranslateService);
  ngOnInit() {
    setWindowTitleFromJWT();
  }
}
